import * as React from "react"
import { Container } from "react-bootstrap"
import { StaticImage } from "gatsby-plugin-image"

import { Grid } from "@mui/material"

import Layout from "../components/layout"
import Seo from "../components/seo"


const ArtistBiographyPage = ({location}) => {
	return (
		<Layout location={location}>
			<Seo title="Artist Biography" />
			<Container>
				<h1>Artist Biography</h1>
				<Grid container columnSpacing={2}>
					<Grid item xs={8}>
						<p>
							Born in 1950, Singapore, Dr. Ho Chee Lick was a linguist teaching at the National University of Singapore and a self-taught artist. His main research interests include cross-cultural communication, language ideology, and translation. Often carrying some painting materials with him, he enjoys going from place to place in the city to observe the everyday lives of common Singaporeans and translate his perspectives and feelings onto his canvas. In December 2011, he came across a run-down Monkey God temple along Marne Road, which sparked his interest in capturing Singapore's beautiful multi-religious landscape. Up to this point, he has produced 396 pieces of mixed media drawing in this series.
						</p>
						<p>
							何自力博士（1950年生于新加坡）是一位语言学者，曾在新加坡国立大学执教。他的教学和研究范围包括跨文化交流、语言与意识形态以及翻译。他也是一个自学的画家，经常爱带着绘画工具穿梭在城市中，观察普通百姓的日常生活，将自己的所见所感跃然纸上。2011年12月有一天，位于马恩路的一座年久失修的花果山庙激起了他捕捉新加坡多元宗教之美的热情；到此时，他已创作了396幅以宗教为主题的、蜡笔水彩混合的系列画作。
						</p>
						<p>
							Click <a
								href="https://www.youtube.com/watch?v=h_quFJ766oI"
								target="_blank"
								rel="noreferrer"
							>
								here
							</a> to see video interview of Dr. Ho Chee Lick
						</p>
					</Grid>
					<Grid item xs={4}>
						<StaticImage src="../images/dr_ho_portrait_s.jpg" alt="Artist Biography" />
					</Grid>
				</Grid>
			</Container>
		</Layout>
	)
}

export default ArtistBiographyPage
